export function isReleaseEligibleFromDocs(seaCargoDoc) {
  if (!Array.isArray(seaCargoDoc)) return false

  return seaCargoDoc.some(doc => {
    if (!doc) return false
    const docType = doc.docType
    if (docType !== 'HBL' && docType !== 'MBL') return false
    return Number(doc.releaseState) === 1 || Number(doc.releaseState) === 2
  })
}

export function getReleaseEligibleLabel(seaCargoDoc, t, tContext) {
  const eligible = isReleaseEligibleFromDocs(seaCargoDoc)
  if (typeof t !== 'function') {
    return eligible ? 'SeaExport.ReleaseEligibleYes' : 'SeaExport.ReleaseEligibleNo'
  }
  const translate = tContext ? (key) => t.call(tContext, key) : t
  return eligible ? translate('SeaExport.ReleaseEligibleYes') : translate('SeaExport.ReleaseEligibleNo')
}
